import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { Link } from 'react-router-dom';

function AuthorDashboard() {
  const [totalPaper, setTotalPaper] = useState(0);
  const [totalAcceptedPaper, setTotalAcceptedPaper] = useState(0);
  const [totalRejectedPaper, setTotalRejectedPaper] = useState(0);
  const [totalPendingPaper, setTotalPendingPaper] = useState(0);
  const [totalFullPaper, setTotalFullPaper] = useState(0);
  const [totalAbstractPaper, setTotalAbstractPaper] = useState(0);
  const [totalRevisionPaper, setTotalRevisionPaper] = useState(0);

  const [acceptedAbstract, setAcceptedAbstract] = useState(0);
  const [pendingAbstract, setPendingAbstract] = useState(0);
  const [rejectedAbstract, setRejectedAbstract] = useState(0);

  const [acceptedFull, setAcceptedFull] = useState(0);
  const [pendingFull, setPendingFull] = useState(0);
  const [rejectedFull, setRejectedFull] = useState(0);

  const [acceptedRevision, setAcceptedRevision] = useState(0);
  const [pendingRevision, setPendingRevision] = useState(0);
  const [rejectedRevision, setRejectedRevision] = useState(0);

  const token = localStorage.getItem('authToken');
  let authorID = localStorage.getItem('AuthorID');
  const PlatformID = localStorage.getItem('platformID');
  const API = process.env.REACT_APP_API_BASE_URL;

  if (token) {
    const decoded = jwtDecode(token);
    authorID = decoded.id;
  }

  useEffect(() => {
    const fetchPaperCounts = async () => {
      try {
        const res = await axios.get(`${API}/api/author/papers/${PlatformID}/${authorID}`);
        const allPapers = res.data.totalPaper || [];

        setTotalPaper(allPapers.length);

        const normalizedPapers = allPapers.map(paper => {
          if (paper.Status?.toLowerCase() === 'pending' && paper.IsReview === 'Reviewed') {
            return { ...paper, Status: 'accept' };
          }
          return { ...paper, Status: paper.Status?.toLowerCase() };
        });

        setTotalAcceptedPaper(normalizedPapers.filter(p => p.Status === 'accept').length);
        setTotalRejectedPaper(normalizedPapers.filter(p => p.Status === 'reject').length);
        setTotalPendingPaper(normalizedPapers.filter(p => p.Status === 'pending').length);

        setTotalFullPaper(normalizedPapers.filter(p => getType(p.SubmissionTitle) === 'Full').length);
        setTotalAbstractPaper(normalizedPapers.filter(p => getType(p.SubmissionTitle) === 'Abstract').length);
        setTotalRevisionPaper(normalizedPapers.filter(p => getType(p.SubmissionTitle) === 'Revision').length);

        setAcceptedAbstract(normalizedPapers.filter(p => getType(p.SubmissionTitle) === 'Abstract' && p.Status === 'accept').length);
        setPendingAbstract(normalizedPapers.filter(p => getType(p.SubmissionTitle) === 'Abstract' && p.Status === 'pending').length);
        setRejectedAbstract(normalizedPapers.filter(p => getType(p.SubmissionTitle) === 'Abstract' && p.Status === 'reject').length);

        setAcceptedFull(normalizedPapers.filter(p => getType(p.SubmissionTitle) === 'Full' && p.Status === 'accept').length);
        setPendingFull(normalizedPapers.filter(p => getType(p.SubmissionTitle) === 'Full' && p.Status === 'pending').length);
        setRejectedFull(normalizedPapers.filter(p => getType(p.SubmissionTitle) === 'Full' && p.Status === 'reject').length);

        setAcceptedRevision(normalizedPapers.filter(p => getType(p.SubmissionTitle) === 'Revision' && p.Status === 'accept').length);
        setPendingRevision(normalizedPapers.filter(p => getType(p.SubmissionTitle) === 'Revision' && p.Status === 'pending').length);
        setRejectedRevision(normalizedPapers.filter(p => getType(p.SubmissionTitle) === 'Revision' && p.Status === 'reject').length);

      } catch (error) {
        console.error('Error fetching paper counts:', error);
      }
    };

    if (authorID) {
      fetchPaperCounts();
    }
  }, [authorID, PlatformID, API]);

  const getType = (title = '') => {
    const lower = title.toLowerCase();
    if (lower.includes('abstract')) return 'Abstract';
    if (lower.includes('full')) return 'Full';
    if (lower.includes('revision')) return 'Revision';
    return 'Unknown';
  };

  // ✅ Reusable Box Component
  const DashboardBox = ({ label, count, bg, to, state }) => (
    <div className="col-lg-3 col-6 mb-4">
      <Link to={to} state={state} className="text-decoration-none">
        <div className={`small-box bg-${bg}`}>
          <div className="inner">
            <h3>{count}</h3>
            <p>{label}</p>
          </div>
        </div>
      </Link>
    </div>
  );

  return (
    <div className="ml-2">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-16">
              <h1 className="m-0 page-title">Dashboard</h1>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row">

            {/* Overall Stats */}
            <DashboardBox label="Total Submissions Uploaded" count={totalPaper} bg="info" to="/author/all-papers" />
            <DashboardBox label="Total Submissions Accepted" count={totalAcceptedPaper} bg="success" to="/author/all-papers" state={{ defaultStatusFilter: 'accept', defaultTypeFilter: 'all' }} />
            <DashboardBox label="Total Pending Submissions" count={totalPendingPaper} bg="warning" to="/author/all-papers" state={{ defaultStatusFilter: 'pending', defaultTypeFilter: 'all' }} />
            <DashboardBox label="Total Rejected Submissions" count={totalRejectedPaper} bg="danger" to="/author/all-papers" state={{ defaultStatusFilter: 'reject', defaultTypeFilter: 'all' }} />

            <h3 className="mt-4">Abstract Papers</h3>
            <DashboardBox label="Abstract Submissions" count={totalAbstractPaper} bg="secondary" to="/author/all-papers"state={{ defaultStatusFilter: 'all', defaultTypeFilter: 'abstract' }}  />
            <DashboardBox label="Accepted Submissions" count={acceptedAbstract} bg="success" to="/author/all-papers" state={{ defaultStatusFilter: 'accept' , defaultTypeFilter: 'abstract'}} />
            <DashboardBox label="Pending Submissions" count={pendingAbstract} bg="warning" to="/author/all-papers" state={{ defaultStatusFilter: 'pending', defaultTypeFilter: 'abstract' }} />
            <DashboardBox label="Rejected Submissions" count={rejectedAbstract} bg="danger" to="/author/all-papers" state={{ defaultStatusFilter: 'reject', defaultTypeFilter: 'abstract' }} />

            <h3 className="mt-4">Full Papers</h3>
            <DashboardBox label="Full Submissions" count={totalFullPaper} bg="primary" to="/author/all-papers" state={{ defaultStatusFilter: 'all', defaultTypeFilter: 'full' }} />
            <DashboardBox label="Accepted Full Submissions" count={acceptedFull} bg="success" to="/author/all-papers" state={{ defaultStatusFilter: 'accept',  defaultTypeFilter: 'full' }} />
            <DashboardBox label="Pending Full Submissions" count={pendingFull} bg="warning" to="/author/all-papers" state={{ defaultStatusFilter: 'pending', defaultTypeFilter: 'full' }} />
            <DashboardBox label="Rejected Full Submissions" count={rejectedFull} bg="danger" to="/author/all-papers" state={{ defaultStatusFilter: 'reject' , defaultTypeFilter: 'full'}} />

            <h3 className="mt-4">Revision Papers</h3>
            <DashboardBox label="Revision Submissions" count={totalRevisionPaper} bg="dark" to="/author/all-papers"state={{ defaultStatusFilter: 'all', defaultTypeFilter: 'revision' }}  />
            <DashboardBox label="Accepted Revision Submissions" count={acceptedRevision} bg="success" to="/author/all-papers" state={{ defaultStatusFilter: 'accept', defaultTypeFilter: 'revision' }} />
            <DashboardBox label="Pending Revision Submissions" count={pendingRevision} bg="warning" to="/author/all-papers" state={{ defaultStatusFilter: 'pending' , defaultTypeFilter: 'revision'}} />
            <DashboardBox label="Rejected Revision Submissions" count={rejectedRevision} bg="danger" to="/author/all-papers" state={{ defaultStatusFilter: 'reject', defaultTypeFilter: 'revision' }} />

          </div>
        </div>
      </section>
    </div>
  );
}

export default AuthorDashboard;
